<template>
  <DialogoFormulario
    :ref="refDialogo"
    title="Alterar quantidade"
    width="400"
    :handler="handleSubmit"
    @enviado="$emit('enviado')"
  >
    <template v-slot="{ form }">
      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="form.quantidade"
            type="number"
            label="Quantidade"
            autofocus
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
  </DialogoFormulario>
</template>

<script>
import DialogoFormulario from "@/components/dialogos/DialogoFormulario.vue";
import DialogoFormularioMixin from "@/mixins/DialogoFormularioMixin";
import locacoes from "@/services/locacoes.js";

export default {
  mixins: [DialogoFormularioMixin],

  components: {
    DialogoFormulario
  },

  props: {},

  data() {
    return {};
  },

  methods: {
    async handleSubmit(form) {
      await locacoes.ordens_transporte.atualizarItem(form.id, form);
    }
  },

  computed: {}
};
</script>
